import { Card, CardContent, Typography, Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledCard = styled(Card)(({ theme }) => ({
  height: "100%",
  position: "relative",
  "&:hover": {
    boxShadow: theme.shadows[5],
  },
}));

export const StyledCardContent = styled(CardContent)(({ theme }) => ({}));

export const StyledHeaderBox = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: theme.spacing(2),
}));

export const StyledMetricValue = styled(Typography)(({ theme }) => ({
  fontSize: "1.5rem",
  fontWeight: 700,
  marginBottom: theme.spacing(4),
}));

export const StyledProgressContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

export const StyledRiskBar = styled(Box)(({ theme }) => ({
  display: "flex",
  height: "6px",
  gap: theme.spacing(0.5),
  overflow: "hidden",
  marginTop: theme.spacing(2),
}));

export const StyledRiskSegment = styled(Box)<{ color: string; width: number }>(
  ({ theme, color, width }) => ({
    backgroundColor: (theme.palette as any)[color]?.main || color,
    borderRadius: "4px",
    width: `${width}%`,
    height: "100%",
  })
);

export const StyledStatContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(5),
  marginTop: theme.spacing(1),
}));

export const StyledStatItem = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
}));

export const StyledStatItemLabel = styled(Typography)<{ color?: string }>(
  ({ theme, color }) => ({
    fontSize: "0.625rem",
    fontWeight: theme.typography.fontWeightBold,
    color: color || theme.palette.text.secondary,
    textTransform: "uppercase",
  })
);

export const StyledStatItemValue = styled(Typography)<{ color?: string }>(
  ({ theme, color }) => ({
    fontSize: "0.8rem",
    fontWeight: theme.typography.fontWeightMedium,
    color: color || theme.palette.text.primary,
  })
);

export const StyledStatItemIcon = styled(Box)<{ color?: string }>(
  ({ theme }) => ({
    display: "flex",
    alignItems: "center",
  })
);
